import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3a938559&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style1 from "./index.vue?vue&type=style&index=1&id=3a938559&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a938559",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod-gz-clzjn-management-platform-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a938559')) {
      api.createRecord('3a938559', component.options)
    } else {
      api.reload('3a938559', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3a938559&scoped=true", function () {
      api.rerender('3a938559', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/module/staff/index.vue"
export default component.exports